/*
 * @prettier
 */

/**
 * @param {number} timeout timeout duration in minutes
 */
function IdleWatcher(timeout) {
  this.interval = null;
  this.timeout = timeout * 60 * 1000;
  this.idleTime = 0;
  this.activityEvents = [
    "mousemove",
    "click",
    "touchstart",
    "keydown",
    "scroll",
  ];

  this.idleThresholds = [0.75, 0.9];

  this.idleThresholdTimes = function () {
    return this.idleThresholds.map(
      function (t) {
        return this.timeout * t;
      }.bind(this)
    );
  };

  /**
   * @type number
   */
  this.lastActivity = Date.now();

  /**
   * Returns the percentage of the timeout duration that has been idled when
   * specific percentages/thresholds are reached.
   *
   * It returns when 75%, 90%, and 100% of the timeout duration have been idled.
   * This enables us to notify the user with increasing urgency before finally
   * triggering the logout.
   *
   * @returns {number} the percentage of the timeout time that has been idled
   * (as decimal)
   */
  this.idledTreshold = function () {
    this.idleTime = Date.now() - this.lastActivity;

    // var thresholds = this.idleThresholdTimes();

    // if (this.idleTime >= thresholds[0] && this.idleTime < thresholds[1]) {
    //   return this.idleThresholds[0];
    // }

    // if (this.idleTime >= thresholds[1]) {
    //   return this.idleThresholds[1];
    // }

    if (this.idleTime >= this.timeout) {
      return 1;
    }
  };

  /**
   *
   * @param {(idleThreshold: number) => void} callbackFn `idleThreshold` indicates how much of the inactive time has elapsed: 0.75 (75% or 3/4), .90 (90%), 1 (100%) - completely elapsed
   */
  this.checkInactivity = function (callbackFn) {
    var threshold = this.idledTreshold();

    if (threshold) {
      callbackFn(threshold);
    }
  };

  this.markActivity = function () {
    this.lastActivity = Date.now();
  };

  this.start = function (fn) {
    // Check inactivity every second
    function checkWithCallback() {
      this.checkInactivity(fn);
    }

    this.interval = setInterval(checkWithCallback.bind(this), 1000);

    this.listenForActivity();
  };

  this.stop = function () {
    if (this.interval !== null) {
      clearInterval(this.interval);
    }
    this.stopListeningForActivity();
  };

  /**
   *
   * @param {Function} listener
   */
  this.listenForActivity = function () {
    this.activityEvents.forEach(
      function (event) {
        window.addEventListener(event, this.markActivity.bind(this));
      }.bind(this)
    );
  };

  /**
   *
   * @param {Function} listener
   */
  this.stopListeningForActivity = function () {
    this.activityEvents.forEach(
      function (event) {
        window.removeEventListener(event, this.markActivity);
      }.bind(this)
    );
  };
}

module.exports = IdleWatcher;
